import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import hazardReducer from 'state/hazard'
import barrierFormTypeReducer from 'state/BarrierModal/barrierFormType'
import modalStateReducer from 'state/BarrierModal/modalState'
import barrierFormDataReducer from 'state/BarrierModal/barrierFormData'
import barrierFormValidationReducer from 'state/BarrierModal/barrierFormValidationData'
import actionTrackerModalReducer from "state/ActionManagement/actionTrackerPopupState"
import actionTrackerEditReducer from "state/ActionManagement/actionTrackerEditDataState"
import projectPermissionsReducer from 'state/projectPermissionsState'
import actionTrackerInsightReducer from'state/ActionManagement/InsightGraphsDataState'
import ActionTrackerTableConfig from 'state/ActionManagement/ActionTrackerTableConfig'
import PSEFormDataconfig from 'state/ProcessSafetyElement/PSEAuditForm'
import AVPEditPermissionFilterReducer from 'state/AVPPermissions/PermissionFilter'

export const store = configureStore({
  reducer: {
    hazard: hazardReducer,
    formType: barrierFormTypeReducer,
    modal: modalStateReducer,
    formData: barrierFormDataReducer,
    barrierValidationData: barrierFormValidationReducer,
    actionModal: actionTrackerModalReducer,
    actioneditData: actionTrackerEditReducer,
    projectPermissions: projectPermissionsReducer,
    actionTrackerInsightData: actionTrackerInsightReducer,
    actionTrackerTableData: ActionTrackerTableConfig,
    PSEAuditFormData: PSEFormDataconfig,
    AVPEditPermissionFilterReducer: AVPEditPermissionFilterReducer
  },
})

export type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch
type DispatchFunc = () => AppDispatch

export const useAppDispatch: DispatchFunc = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector